exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".uk-notification-message {\n\tbackground-color: #F6F4F0;\n\tfont-size: 1rem;\n\tborder-radius: 10px;\n\tfont-weight: bold;\n\ttext-align: center;\n}", ""]);

